"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-radio-group", {
    on: {
      change: _vm.handleChange
    },
    model: {
      value: _vm.modelValue,
      callback: function ($$v) {
        _vm.modelValue = $$v;
      },
      expression: "modelValue"
    }
  }, _vm._l(_vm.currentUserList, function (user) {
    return _c("div", {
      key: user.userIdAndDepartmentId,
      staticClass: "user-item"
    }, [_c("a-radio", {
      attrs: {
        value: user.userIdAndDepartmentId
      }
    }, [_c("a-avatar", {
      staticStyle: {
        "background-color": "#2483ff"
      },
      attrs: {
        size: "small",
        src: user.avatar,
        alt: user.userName
      }
    }, [_vm._v(" " + _vm._s(user.userName) + " ")]), _vm._v(" " + _vm._s(user.userName) + " "), _vm._l(user.roleList, function (role) {
      return _c("a-tag", {
        key: `${user.userId}-${role.id}`
      }, [_vm._v(" " + _vm._s(role.name) + " ")]);
    })], 2)], 1);
  }), 0);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;